import styled from 'styled-components/macro';
import { space } from 'styled-system';

import { SegmentedButton } from '../../SubComponents/Buttons';
import { Label } from '../../SubComponents/Text';
import { colors } from '../../Style/Theme';

const shadow = '0 4px 6px rgb(50 50 93 / 15%), 0 1px 3px rgb(0 0 0 / 10%)';

export const TimeslotButton = styled(SegmentedButton)<{
  localized: boolean;
  warning: boolean;
}>`
  font-size: ${(props) => (props.localized ? '1.5rem' : '1.6rem')};
  min-width: 75px;
  padding: 0;
  margin: 0;

  background-color: ${(props) =>
    props.selected ? props.theme.colors.timeslots.selected.backgroundColor : '#fff'};

  color: ${(props) =>
    props.selected
      ? props.theme.colors.timeslots.selected.textColor
      : props.theme.textColor};

  border: ${(props) =>
    props.warning
      ? `2px solid ${colors.red}`
      : props.theme.name === 'starboard'
      ? `1px solid ${props.theme.colors.primary}`
      : 'none'};
  ${(props) => (props.warning ? 'line-height: 29px;' : null)}
  ${(props) => (props.warning ? 'box-shadow: none;' : null)}

  :disabled {
    line-height: 30px;
    background-color: ${(props) =>
      props.selected ? props.theme.textColor : 'transparent'};
    box-shadow: none;
    border: ${(props) => (props.selected ? 'none' : `1px solid ${colors.lightGray}`)};
    color: ${(props) => (props.selected ? '#fff' : colors.lightGray)};
    cursor: default;
  }

  :hover {
    color: ${(props) => props.theme.textColor};
  }

  :disabled:hover {
    transform: none;
    background-color: ${(props) =>
      props.selected ? props.theme.textColor : 'transparent'};
  }
`;

export const TimeslotWrapper = styled.div`
  padding: 0;
  margin: 0;
  border-radius: 4px;
  padding-bottom: 3px;
  display: flex;
`;

export const VancancyWrapper = styled.div<{ warning: boolean }>`
  width: 100%;
  padding-top: ${(props) => (props.warning ? '3px' : 0)};
  background: ${(props) => (props.warning ? colors.red : 'transparent')};
  border-radius: 4px;
  box-shadow: ${(props) => (props.warning ? shadow : 'none')};
  align-self: flex-end;
  cursor: pointer;
`;

export const VacancyLabel = styled(Label)`
  color: #fff;
  font-size: 1rem;
  text-transform: uppercase;
  pointer-events: none;
`;

export const TimeslotsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 75px);
  grid-gap: 8px;
  justify-content: end;

  ${space}

  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(auto-fill, 1fr);
    justify-content: center;
  }
`;

export const IntervalWrapper = styled.div`
  border: 1px dashed ${(props) => props.theme.textColor};

  border-radius: 16px;
  padding: 16px 0;
  position: relative;
  width: 100%;
  margin-bottom: 32px;

  @media screen and (min-width: 768px) {
    margin-left: auto;
    padding: 16px 14px 13px;
    max-width: 190px;
  }

  @media screen and (min-width: 964px) {
    padding: 16px 16px 13px;
    max-width: 275px;
  }

  @media screen and (min-width: 1126px) {
    max-width: 358px;
  }
`;

export const IntervalPrice = styled(Label)`
  position: absolute;
  top: -10px;
  left: 16px;
  background-color: #f5f5f5;
  padding: 0 16px;
  color: ${(props) => props.theme.textColor};
`;
